import { createClient } from '@supabase/supabase-js';

const supabaseUrl =
  process.env.REACT_APP_SUPABASE_URL ??
  (process.env.NODE_ENV === 'test' ? 'http://localhost:54321' : undefined);
const supabaseAnonKey =
  process.env.REACT_APP_SUPABASE_ANON_KEY ??
  (process.env.NODE_ENV === 'test' ? 'test-anon-key' : undefined);

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error(
    'Missing Supabase configuration. Set REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_ANON_KEY.'
  );
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
